import { RegionData } from '@/editor/data/region/Region';
import { globalStores } from '@/editor/stores';
import { IPoint2d } from '@/editor/math/IPoint2d';
import { Curve2dUtils } from '@/editor/math/Curve2dUtils';
import { Polylabel } from '@/editor/math/Polylabel';
import { getAreaInfo } from '@/editor/utils/room/area';
import { dispersePath } from '../shape';
import { getPathFromEdges } from '../edge';
import { calculatePolygonArea } from '@/editor/model/polygon/utils';

export function equalsOutline(
  regionData1: { path: IPoint2d[]; holes: IPoint2d[][] },
  regionData2: { path: IPoint2d[]; holes: IPoint2d[][] }
) {
  const path1 = regionData1.path.concat(regionData1.holes.flat());
  const path2 = regionData2.path.concat(regionData2.holes.flat());
  if (regionData1.path.length !== regionData2.path.length) {
    return false;
  }
  if (!path1.every((point, index) => point.x === path2[index].x && point.y === path2[index].y)) {
    return false;
  }

  return true;
}

/**
 * 获取开洞多边形的质心
 *
 * 质心点不在多边形内部（或落在洞内）时，取最难抵达点（最大内切圆圆心）作为质心
 */
export function getRegionCentroid(regionData: Pick<RegionData, 'corePathInfos' | 'pathInfos' | 'holeInfos'>): IPoint2d {
  // 获取离散值
  // 分区内轮廓的边界
  let path = dispersePath(getPathFromEdges(regionData.pathInfos));
  const area = calculatePolygonArea(path) / (1000 * 1000);
  if (area <= 0.1) {
    // 分区内轮廓数据可能已经出问题了，要用中线计算
    path = dispersePath(getPathFromEdges(regionData.corePathInfos));
  }
  const holes = regionData.holeInfos.map((holes) => dispersePath(getPathFromEdges(holes)));

  const centroid = Curve2dUtils.calculatePolygonWithHolesCentroid(path, holes);

  const insidePath = Curve2dUtils.isPointInPolygon(centroid, path);
  const insideHole = holes.some((hole) => Curve2dUtils.isPointInPolygon(centroid, hole));
  if (insidePath && !insideHole) {
    return centroid;
  }

  return Polylabel.findPoleOfInaccessibility([path, ...holes], 10).center;
}

/**
 * 计算区域面积，单位：平方米
 * @param regionData
 * @returns
 */
export function getRegionArea(regionData: RegionData): number {
  const isSingleRegion = globalStores.regionStore.getRoomRegions(regionData.relateRoomId).length === 1;
  if (isSingleRegion) {
    const roomData = globalStores.roomStore.getRoomData(regionData.relateRoomId);
    if (roomData) {
      return getAreaInfo(roomData).coreArea;
    }
  }

  return getAreaInfo(regionData).coreArea;
}
